import $ from 'jquery';

const img = $('.player-single-thumb img');
const setThumbWidth = () => {
    const bodyWidth = $('body').outerWidth();

    if (window.matchMedia('(max-width: 991.98px)').matches) {
        img.css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    } else {
        img.css({
            width: '',
            marginLeft: '',
        });
    }
};

$(window).bind('resize', setThumbWidth).trigger('resize');
